import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SkillBar = ({ name, percentage }) => {
  return (
    <SkillBarContainer>
      <SkillInfo>
        <SkillName>{name}</SkillName>
        <SkillPercentage>{percentage}%</SkillPercentage>
      </SkillInfo>
      <SkillBarWrapper>
        <SkillBarFill
          initial={{ width: 0 }}
          whileInView={{ width: `${percentage}%` }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: 'easeOut' }}
        />
      </SkillBarWrapper>
    </SkillBarContainer>
  );
};

const SkillBarContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const SkillInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

const SkillName = styled.span`
  font-weight: 500;
  
  .light & {
    color: var(--text-primary-light);
  }
  
  .dark & {
    color: var(--text-primary-dark);
  }
`;

const SkillPercentage = styled.span`
  .light & {
    color: var(--text-secondary-light);
  }
  
  .dark & {
    color: var(--text-secondary-dark);
  }
`;

const SkillBarWrapper = styled.div`
  height: 8px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  
  .dark & {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const SkillBarFill = styled(motion.div)`
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--primary-light), var(--secondary-light));
  
  .dark & {
    background: linear-gradient(90deg, var(--primary-dark), var(--secondary-dark));
  }
`;

export default SkillBar;